import React from "react";

export default function EmptyState({ isSuperAdmin, onAddClick }) {
  if (isSuperAdmin) {
    return (
      <div className="flex-1 px-8 py-20 flex flex-col items-center justify-center text-center">
        <div className="h-20 w-20 rounded-2xl bg-blue-50 flex items-center justify-center mb-6">
          <svg className="h-10 w-10 text-blue-500" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-slate-900 mb-2">No apps registered yet</h2>
        <p className="text-sm text-slate-500 max-w-md mb-6 leading-relaxed">
          Onboard your first internal app to enable single sign-on for Zuper employees.
        </p>
        <button
          onClick={onAddClick}
          className="inline-flex items-center gap-1.5 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold px-5 py-2.5 rounded-md shadow-sm"
        >
          Add your first app
        </button>
      </div>
    );
  }

  return (
    <div className="flex-1 px-8 py-20 flex flex-col items-center justify-center text-center">
      <div className="h-20 w-20 rounded-2xl bg-slate-100 flex items-center justify-center mb-6">
        <svg className="h-10 w-10 text-slate-400" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
        </svg>
      </div>
      <h2 className="text-xl font-bold text-slate-900 mb-2">No apps available to you</h2>
      <p className="text-sm text-slate-500 max-w-md leading-relaxed">
        You don't currently have access to any internal apps. Contact your administrator if you believe you should have access to one.
      </p>
    </div>
  );
}
